import type { ScreenSchema } from './types';

/**
 * Schema for the `result` template (screen-result.vue).
 *
 * `managesOwnSectionAudio: true` — screen-result.vue owns the full audio
 * sequence so it can chain the intro → result child screens in the correct
 * order. Without this flag the generic uc-screen sectionActive watcher would
 * play the intro independently and race with screen-result.vue's own watches.
 *
 * Audio sequence on section entry (or re-entry):
 *   1. play intro  (heading / text / instructions from the result screen itself)
 *   2. queue each result child screen's intro in order (passed / failed / etc.)
 */
const resultSchema: ScreenSchema = {
  template: 'result',
  managesOwnSectionAudio: true,
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    }
  }
};

export default resultSchema;
